import { styled } from "@mui/material/styles";
import { Paper } from "@mui/material";
import { semantic, hexToRGBA } from "../../common/theme/brandTokens";

export const StyledHeaderBox = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  mb: 2,
} as const;

export const StyledHeaderTitle = {
  variant: "h5",
  fontWeight: 700,
  mb: 0.5,
} as const;

export const StyledHeaderSubtitle = {
  variant: "body2",
  color: "text.secondary",
} as const;

export const StyledErrorPaper = styled(Paper)(({ theme }) => ({
  padding: "16px",
  marginBottom: "16px",
  borderRadius: 8,
  backgroundColor: theme.palette.mode === 'dark' ? hexToRGBA(semantic.error.main, 0.15) : theme.palette.error.light,
  color: theme.palette.error.dark,
}));

export const StyledTableContainer = styled(Paper)(({ theme }) => ({
  borderRadius: 8,
  boxShadow: theme.palette.mode === 'dark' ? '0 10px 24px rgba(0,0,0,0.35)' : '0 12px 30px rgba(0,0,0,0.08)',
}));

export const StyledStatusDot = {
  width: 10,
  height: 10,
  borderRadius: "50%",
} as const;
